import videojs from 'video.js';
import SpeedButton from './SpeedButton';
const Component = videojs.getComponent('Component');
class SpeedSelector extends Component {
    constructor(player, options, props) {
        super(player, options);
        this.addClass('selector-container');
        player.ready(() => {
            this.mount(props);
        });
    }
    mount(props) {
        props.options.forEach((option) => {
            const player = this.player();
            const selected = option.value === props.default;
            this.addChild(new SpeedButton(player, {}, { value: option.value, handleClick: props.handleClick, selected }));
        });
    }
}
export default SpeedSelector;
//# sourceMappingURL=SpeedSelector.js.map